import {
  CATEGORIES,
  HAKLAI_PTOR_TYPES
} from "./haklaiConstants";

const isPlainObject = (value) => (
  value
  && typeof value === "object"
  && !Array.isArray(value)
);

const getSortedResidentialEntries = (propertyPartsData = {}) => (
  Object.entries(propertyPartsData || {})
    .filter(([, part]) => part?.category === CATEGORIES.RESIDENTIAL)
    .sort(([firstKey], [secondKey]) => {
      const firstIndex = Number(String(firstKey).split("_")[1]);
      const secondIndex = Number(String(secondKey).split("_")[1]);
      if (Number.isFinite(firstIndex) && Number.isFinite(secondIndex)) {
        return firstIndex - secondIndex;
      }
      return String(firstKey).localeCompare(String(secondKey));
    })
);

export const sanitizeHaklaiPtorTypeForWay = (
  ptorType = HAKLAI_PTOR_TYPES.NONE,
  wayOfGettingProperty = ""
) => {
  if (ptorType === HAKLAI_PTOR_TYPES.SINGLE) return HAKLAI_PTOR_TYPES.SINGLE;
  if (
    ptorType === HAKLAI_PTOR_TYPES.INHERITANCE
    && wayOfGettingProperty === "inheritance"
  ) {
    return HAKLAI_PTOR_TYPES.INHERITANCE;
  }
  return HAKLAI_PTOR_TYPES.NONE;
};

export const getHaklaiSelectedPtor = (propertyPartsData = {}, preCalc = {}) => {
  const wayOfGettingProperty = preCalc?.wayOfGettingProperty || "";
  const residentialEntries = getSortedResidentialEntries(propertyPartsData);
  const hasBlockingTzinun = (
    wayOfGettingProperty === "gift"
    && preCalc?.hasTzinunOnPtor === true
  );

  if (hasBlockingTzinun) {
    return {
      partKey: "",
      ptorType: HAKLAI_PTOR_TYPES.NONE,
      isLegacy: false
    };
  }

  for (const [partKey, part] of residentialEntries) {
    const ptorType = sanitizeHaklaiPtorTypeForWay(part?.ptorType, wayOfGettingProperty);
    if (ptorType !== HAKLAI_PTOR_TYPES.NONE) {
      return { partKey, ptorType, isLegacy: false };
    }
  }

  const legacyPtorType = sanitizeHaklaiPtorTypeForWay(
    preCalc?.ptorType,
    wayOfGettingProperty
  );
  if (legacyPtorType !== HAKLAI_PTOR_TYPES.NONE && residentialEntries.length > 0) {
    return {
      partKey: residentialEntries[0][0],
      ptorType: legacyPtorType,
      isLegacy: true
    };
  }

  return {
    partKey: "",
    ptorType: HAKLAI_PTOR_TYPES.NONE,
    isLegacy: false
  };
};

export const normalizeHaklaiPropertyPartPtorSelections = (
  propertyPartsData = {},
  preCalc = {},
  { applyLegacy = true } = {}
) => {
  const selectedPtor = getHaklaiSelectedPtor(propertyPartsData, preCalc);
  const selectedPartKey = applyLegacy ? selectedPtor.partKey : (
    selectedPtor.isLegacy ? "" : selectedPtor.partKey
  );
  const selectedPtorType = selectedPartKey
    ? selectedPtor.ptorType
    : HAKLAI_PTOR_TYPES.NONE;
  let changed = false;

  const nextPropertyPartsData = Object.entries(propertyPartsData || {}).reduce((acc, [partKey, part]) => {
    if (!isPlainObject(part)) {
      acc[partKey] = part;
      return acc;
    }

    const isResidential = part.category === CATEGORIES.RESIDENTIAL;
    const nextPtorType = (
      isResidential && partKey === selectedPartKey
        ? selectedPtorType
        : HAKLAI_PTOR_TYPES.NONE
    );
    const currentPtorType = part.ptorType;

    if (currentPtorType !== nextPtorType) {
      changed = true;
      acc[partKey] = { ...part, ptorType: nextPtorType };
      return acc;
    }

    acc[partKey] = part;
    return acc;
  }, {});

  return {
    changed,
    propertyPartsData: changed ? nextPropertyPartsData : propertyPartsData,
    selectedPartKey,
    selectedPtorType
  };
};
